<script>
import { mapActions } from 'vuex';

export default {
  name: 'GuestModal',
  methods: {
    ...mapActions(['navigateToPay']),
    pay() {
      this.$emit('close');
      this.navigateToPay();
    }
  }
}
</script>

<template>
  <div class="backdrop" @click.self="$emit('close')">
    <div class="modal">
      <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#000000"><path d="M753-249q27.92 0 47.46-19.56t19.54-47.5Q820-344 800.46-363q-19.54-19-47.46-19-27.5 0-46.75 19.35-19.25 19.36-19.25 47 0 27.65 19.25 47.15T753-249Zm-.21 133Q786-116 815-131.5t47-42.5q-26-14-53-22.5t-56-8.5q-29 0-56 8.5T644-174q18 27 46.79 42.5 28.78 15.5 62 15.5ZM350-634h260v-93q0-57-37.5-95T480-860q-55 0-92.5 38T350-727v93ZM557-80H220q-23 0-41.5-18.5T160-140v-434q0-23 18.5-41.5T220-634h70v-93q0-81 55-137t135-56q80 0 135 56t55 137v93h70q23 0 41.5 18.5T800-574v87q-13-3-27-4t-33-1v-82H220v434h301q7 17 15 30.5T557-80Zm196 34q-79 0-136-57t-57-136q0-79 57-136t136-57q79 0 136 57t57 136q0 79-57 136T753-46ZM220-574v434-434Z"/></svg>
      <p>
        Чтобы открыть этот раздел, активируйте полную версию. 
        Сразу после оплаты вам станут доступны все программы и все страницы.
      </p>
      <button @click="pay()">
        Купить полную версию
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.line {
    border-top: 1px solid #0000001A;
    width: 100%;
}
.backdrop {
  position: fixed;
  inset: 0;
  z-index: 9000;
  background-color: rgba(0, 0, 0, 0.4);

  .modal {
    position: absolute;
    z-index: 9001;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    max-width: 90%;
    max-height: 90%;
    overflow-y: auto;
    width: 70%;
    height: fit-content;
    padding: min(max(24px, calc(1.5rem + ((1vw - 7.68px) * 1.3889))), 40px);
    border-radius: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    @media (min-width: 640px) {
      width: 50%;
    }
    @media (min-width: 768px) {
      width: 33%;
    }
    
    p {
      font-size: min(max(14px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 16px);
      text-align: center;
    }

    button {
      padding: 0.5rem 2rem;
      background-color: #11415D;
      color: white;
      border: none;
      border-radius: 10px;
    }
  }
}
</style>
